export default "__VITE_ASSET__DZDB$QXd__"